import { BehaviorSubject } from 'rxjs';
import { FatigueAssessmentForm } from 'shared/models/api/models';


export type FatigueAssessmentFormState = {
    form: FatigueAssessmentForm,
    originalForm: FatigueAssessmentForm,
    formValidation: boolean[],
    checkValidation: boolean
}

const emptyForm: FatigueAssessmentForm = {
    id: -1
};

const createInitialState = (): FatigueAssessmentFormState => ({
    form: Object.assign({}, emptyForm),
    originalForm: emptyForm,
    formValidation: [],
    checkValidation: false
});

const fatigueAssessmentFormStateSubject = new BehaviorSubject<FatigueAssessmentFormState>(createInitialState());

export const updateFormState = (form: FatigueAssessmentForm) => {
    fatigueAssessmentFormState.setState(s => {
        s.form = form;
    });
}

const updateValidationState = (validation: boolean[]) => {
    fatigueAssessmentFormState.setState(s => {
        s.formValidation = validation;
    });
}

const isValueInvalid = (value: any) => {
    if (value === undefined) return true;
    if (typeof (value) === 'string' && !value.trim()) return true;
    return false;
}

const validate = (field: string, value: any) => {
    updateValidationState({ ...fatigueAssessmentFormStateSubject.value.formValidation, [field]: isValueInvalid(value) });
}

export const handleChange = (field: string) => (event: any) => {
    let value = event;

    if (value.target?.value !== undefined) {
        value = value.target.value;
    }
    if (value.value !== undefined) {
        value = value.value;
    }
    updateFormState({ ...fatigueAssessmentFormStateSubject.value.form, [field]: value });
    validate(field, value);

};

export const handleCheckboxChange = (field: string) => (event: any) => {
    let value = event;
    if (value.target?.checked !== undefined) {
        value = value.target.checked;
    } else {
        value = false;
    }

    updateFormState({ ...fatigueAssessmentFormStateSubject.value.form, [field]: value });
    validate(field, value ? value : undefined);
}

// Handle a dropdown change using the label instead of the value
export const handleOptionTextChange = (field: string) => (event: any) => {
    updateFormState({ ...fatigueAssessmentFormStateSubject.value.form, [field]: event.label });
    validate(field, event.label);
}

export const enableValidation = () => {
    fatigueAssessmentFormState.setState(s => { s.checkValidation = true });
};

export const resetValidation = () => {
    fatigueAssessmentFormState.setState(s => { s.formValidation = [], s.checkValidation = false });
};

export const fieldInvalid = (field: string) => {
    if (!fatigueAssessmentFormStateSubject.value.checkValidation) {
        return false;
    }
    let value = Object(fatigueAssessmentFormStateSubject.value.formValidation)[field] as boolean;
    if (value === undefined) return true;
    return value;
}

export const fatigueAssessmentFormState = {
    subscribe: (setState: any) => fatigueAssessmentFormStateSubject.subscribe(setState),
    setState: (fn: (state: FatigueAssessmentFormState) => void) => {
        var newState = Object.assign({}, fatigueAssessmentFormStateSubject.getValue());
        fn(newState);
        fatigueAssessmentFormStateSubject.next(newState);
    },
    reset: () => {
        fatigueAssessmentFormStateSubject.next(createInitialState());
    }
}
